import { Component, OnInit, ViewChild, OnDestroy, Pipe } from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { SearchPrevencionFilters, searchPrevencionResponse } from 'src/app/_models/search-prevencion';
import { ZeroService } from 'src/app/_services/zero/zero.service';
import { REST_SERVICES } from 'src/app/_services/settings';
import { CatalogosService } from 'src/app/_services/catalogos.service';
import { ListaCatalogosModel } from 'src/app/_models/bin-lista-catalogos.model';
import { MzModalService } from 'ngx-materialize';
import { ModalsComponent } from 'src/app/semantic/modals/modals.component';
import { Globals } from 'src/app/_services/zero/globals';
import { DatatableComponent } from '../../semantic/datatable/datatable.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-search-prevencion',
  templateUrl: './search-prevencion.component.html',
  styles: [':host {display: block;}'],
  host: ROUTE_ANIMATION_HOST,
  animations: [ROUTE_ANIMATION],
})
export class SearchPrevencionComponent implements OnInit, OnDestroy {

  constructor(private zeroService: ZeroService,
    private catService: CatalogosService,
    private modalService: MzModalService,
    private global: Globals) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}

